import { render, staticRenderFns } from "./InvitesPage.vue?vue&type=template&id=e0a6e204&scoped=true"
import script from "./InvitesPage.vue?vue&type=script&lang=js"
export * from "./InvitesPage.vue?vue&type=script&lang=js"
import style0 from "./InvitesPage.vue?vue&type=style&index=0&id=e0a6e204&prod&scoped=true&lang=scss"
import style1 from "./InvitesPage.vue?vue&type=style&index=1&id=e0a6e204&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a6e204",
  null
  
)

export default component.exports